import { SThemeThemes } from 'servisofts-component2';
import MapStyle from './mapStyle'

const theme: SThemeThemes = {

    default: {
        barStyle: 'dark-content',
        barColor: '#011D3F',
        text: '#000000',
        primary: '#011D3F',
        secondary: '#ccf531',
        info: '#011D3F',
        background: '#FFFFFF',
        card: '#00000044',
        font: 'Poppins',
        lightGray: '#555555',
        mapStyle: MapStyle,
        // card: '#DA680015',
    },
    dark: {
        barStyle: 'light-content',
        barColor: '#011D3F',
        text: '#ffffff',
        primary: '#011D3F',
        secondary: '#ccf531',
        info: '#011D3F',
        background: '#011D3F',
        card: '#FFFFFF44',
        font: 'Poppins',
        lightGray: '#AAAAAA',
        mapStyle: MapStyle,
        // card: '#ffffff10'
    }

}
export default theme;